var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-layout",
    { attrs: { view: _vm.getView } },
    [
      _c("etraining-header"),
      _c("menu-left"),
      _c(
        "q-page-container",
        [
          _c("etraining-navbar"),
          _c("accept-terms"),
          _c("router-view", { style: _vm.themeStyles })
        ],
        1
      ),
      _c("menu-right"),
      _c("etraining-footer"),
      _c("floating-player"),
      _c("player")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }